import React from 'react';
import { result, isEmpty } from 'underscore';
import $ from 'jquery';
import PropTypes from 'prop-types';
import {
  Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton,
} from '@fluentui/react';
import { notificationApi, NotificationLevel } from '@bingads-webui-react/notification-center';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { withUiBlock } from '@bingads-webui/uiblocker';

import { upgradeCampaignsToPMaxCall } from './api';
import {
  upgradePromptTitle,
  upgradePromptDescription,
  upgradeSuccess,
  upgradeFailure,
} from './constant';

export class StyledCampaignUpgradeDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      i18n,
      isUpgradeDialogOpen,
      closeUpgradeDialog,
      selectedCampaigns,
      scope,
      refreshGrid,
    } = this.props;

    const { values } = scope;
    const { aid, cid } = values;

    const dialogContentProps = {
      type: DialogType.normal,
      title: i18n.getString(upgradePromptTitle),
      showCloseButton: true,
      closeButtonAriaLabel: i18n.getString(_TL_('Close')),
      subText: i18n.getString(upgradePromptDescription),
    };

    const onGenericError = () => {
      const alertHelper = new AlertHelper({ i18n });
      alertHelper.showError(i18n.getString(_TL_('We\'ve encountered an error and can\'t continue. Please contact support for further assistance.')));
    };

    const onUpgradeApiError = (response) => {
      const errors = result(response, 'errors', []);
      if (isEmpty(errors)) {
        onGenericError();
      } else {
        notificationApi.add({
          severity: NotificationLevel.Error,
          message: i18n.getString(upgradeFailure),
          target: 'FloatingBanner',
        });
      }
    };

    const onConfirm = () => {
      const payload = {
        Campaigns: selectedCampaigns.map(campaign => ({
          ParentId: aid,
          EntityId: campaign.Id,
        })),
      };
      closeUpgradeDialog();
      upgradeCampaignsToPMaxCall({
        cid,
        aid,
        payload,
      }).then((response) => {
        const updatedCampaigns = response.value;
        notificationApi.add({
          severity: NotificationLevel.Info,
          message: i18n.getString(upgradeSuccess, { count: updatedCampaigns.length }),
          target: 'FloatingBanner',
        });
        refreshGrid();
      })
        .catch(onUpgradeApiError)
        .finally(withUiBlock($('.campaigns-page')));
    };

    const modalProps = {
      isBlocking: true,
    };

    return (
      <Dialog
        hidden={!isUpgradeDialogOpen}
        onDismiss={closeUpgradeDialog}
        minWidth={500}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          <PrimaryButton
            autoFocus
            className="dialog-confirm"
            onClick={onConfirm}
            text={i18n.getString(_TL_('Apply'))}
          />
          <DefaultButton
            className="dialog-cancel"
            onClick={closeUpgradeDialog}
            text={i18n.getString(_TL_('Cancel'))}
          />
        </DialogFooter>
      </Dialog>
    );
  }
}

StyledCampaignUpgradeDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isUpgradeDialogOpen: PropTypes.bool.isRequired,
  closeUpgradeDialog: PropTypes.func.isRequired,
  selectedCampaigns: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number.isRequired,
  })).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.number,
      cid: PropTypes.number,
    }),
  }).isRequired,
  refreshGrid: PropTypes.func.isRequired,
};
